import React from 'react';
import { Typography, Switch } from 'antd';

const { Text } = Typography;

interface SwitchFieldProps {
  field: any;
  value: boolean | undefined;
  onChange: (v: boolean) => void;
  commonStyle: React.CSSProperties;
  labelStyle: React.CSSProperties;
  error?: string;
}

export const SwitchField: React.FC<SwitchFieldProps> = ({ field, value, onChange, commonStyle, labelStyle, error }) => {
  const checked = typeof value === 'boolean' ? value : !!field.defaultValue;

  return (
    <div
      style={{
        ...commonStyle,
        flexDirection: 'row',
        alignItems: 'center',
        gap: '20px',
        marginBottom: 0
      }}
    >
      <Text type='secondary' style={{ ...labelStyle, textTransform: 'uppercase', margin: 0 }}>
        {field.label}
      </Text>
      <Switch
        checked={checked}
        onChange={onChange}
        style={{
          zIndex: 10,
          background: checked ? 'linear-gradient(135deg, #10b981 0%, #059669 100%)' : undefined
        }}
      />
      {error && (
        <Text type='danger' style={{ fontSize: 12, marginLeft: '8px' }}>
          {error}
        </Text>
      )}
    </div>
  );
};
